<template>
    <div class="content">
        <div class="header pb-6 d-flex align-items-center profile-header" style="min-height: 250px;">
            <!-- Mask -->
            <span class="mask bg-gradient-default" style="background: #A6AB38 !important;"></span>
            <!-- Header container -->
        </div>
        <!-- Page content -->
        <b-container class="mt--9 mb-8">
            <div class="justify-content-center">

                    <b-card v-if="loading" v-loading="loading">
                    </b-card>
                    <b-card style="min-width: 70vw;" no-body class="pt-4 bg-white border-0 mb-0" v-if="!loading">
                        <agent-card v-bind="currentAgentData" :agent="currentAgentData.agent"
                            :formations="currentAgentData.formations" :city="currentAgentData.city"
                            :place="currentAgentData.place" :agentPlaceXfields="currentAgentData.mainPlaceAgentData"
                            :toggleQR="true" />

                    </b-card>

            </div>
        </b-container>
        <div class="col-md-8 col-md-offset-3">
            <b-container fluid class="mt--6 ">
                <b-row>
                    <b-col xl="8" class="order-xl-2">

                        <!-- Progress track -->

                    </b-col>
                </b-row>
            </b-container>
        </div>
    </div>
</template>
<script>
import EditProfileForm from "../Pages/UserProfile/EditProfileForm.vue"
import { formatAgentData } from '../../store/utils/users'
import janooService from '@/services/janoo'
//"./UserProfile/EditProfileForm.vue";
import AgentCard from "./AgentCard.vue"
//import UserCard from "../Pages/UserProfile/UserCard.vue";
import ProgressTrackList from "../Dashboard/ProgressTrackList.vue"
//"@/views/Dashboard/ProgressTrackList";

import bocapioCakeService from "./../../services/cakephp/index";

var axios = require("axios");

export default {
    name: "Agents",
    components: {
        EditProfileForm,
        AgentCard,
        ProgressTrackList
    },
    data() {
        return {
            currentUserPois: false,
            loading: true
        }
    },
    async created() {
        await bocapioCakeService.getAgentByUUID(this.$route.params.uuid).then((rsp) => {
            this.currentAgentData = formatAgentData(rsp.view, 0, [], this.currentUserPois)
            this.loading = false
            document.title = this.currentAgentData.agent.name + ' :: ' + this.currentAgentData.agent.category
            this.getPois()
        })
    },
    methods: {
        async getMap() {
            return axios.get(`${process.env.VUE_APP_API_CAKE_URL}agents/json/map`);
        },

        async getPois() {
            if (!this.currentUserPois) {
                const response = await janooService.getUserProductsList(this.currentAgentData.uuid)
                this.currentUserPois = Object.values(response)
            }
            return this.currentUserPois
        },
        isMobile: function () {
            if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                return true
            } else {
                return false
            }
        }
    }
};
</script>

<style>
.header .bg-gradient-default {
    /* background-color: #81175a; */
}

.profile-header {
    background-size: cover;
    background-position: center top;
    min-height: 500px;
}

.carteirinha {
    background-color: white;
    width: 350px;
}
</style>
